export const isFullStatic = false
export const staticPath = "/root/project/frontend/.nuxt/static-json"
export const publicPath = "https://frontenddev.builtin.com/2cf16b7d2c356f1c6fd63faf96907b26b9657216/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"